import { render, staticRenderFns } from "./FilterMenuQuotaSource.vue?vue&type=template&id=47e048ca"
import script from "./FilterMenuQuotaSource.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterMenuQuotaSource.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports